import React from 'react';
import {Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button as MuiButton} from "@mui/material";

interface IProps {
    open: boolean;
    title: string;
    text: string;
    confirmText?: string;
    cancelText?: string;
    isLoading?: boolean;
    onConfirm: () => void;
    onCancel: () => void;
}

const ConfirmDialog: React.FC<IProps> = ({
    open,
    title,
    text,
    confirmText = 'Підтвердити',
    cancelText = 'Скасувати',
    isLoading = false,
    onConfirm,
    onCancel,
}) => {
    const handleClose = () => {
        if (isLoading) return;
        onCancel();
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            maxWidth={'xs'}
            fullWidth
            PaperProps={{sx: {borderRadius: '16px', padding: '8px'}}}
        >
            <DialogTitle sx={{color: '#1E1E1E', fontSize: '18px', fontWeight: 500}}>
                {title}
            </DialogTitle>
            <DialogContent>
                <DialogContentText sx={{color: '#565656', fontSize: '14px'}}>
                    {text}
                </DialogContentText>
            </DialogContent>
            <DialogActions sx={{padding: '8px 24px 20px', gap: '8px'}}>
                <MuiButton
                    onClick={onCancel}
                    disabled={isLoading}
                    disableElevation
                    sx={{
                        color: '#959595',
                        fontWeight: 500,
                        textTransform: 'none',
                        borderRadius: '16px',
                    }}
                >
                    {cancelText}
                </MuiButton>
                <MuiButton
                    onClick={onConfirm}
                    disabled={isLoading}
                    variant={'contained'}
                    disableElevation
                    sx={{
                        backgroundColor: '#1E1E1E',
                        color: '#FFF',
                        fontWeight: 500,
                        textTransform: 'none',
                        borderRadius: '16px',
                        padding: '8px 20px',
                        '&:hover': {backgroundColor: '#393939'},
                        '&:disabled': {backgroundColor: '#C7C7C7', color: '#FFF'},
                    }}
                >
                    {isLoading ? 'Виконання...' : confirmText}
                </MuiButton>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmDialog;
